
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"48","height":"48","xmlns":"http://www.w3.org/2000/svg","preserveAspectRatio":"xMidYMid meet"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M23.47 15.274a2.153 2.153 0 01.531 4.238L24 24.5h14a2.5 2.5 0 012.495 2.336L40.5 27v10a2.5 2.5 0 01-2.5 2.5H10A2.5 2.5 0 017.5 37V27a2.5 2.5 0 012.5-2.5h13v-4.974a2.154 2.154 0 01.47-4.252zM38 25.5H10A1.5 1.5 0 008.5 27v10a1.5 1.5 0 001.5 1.5h28a1.5 1.5 0 001.5-1.5V27a1.5 1.5 0 00-1.5-1.5zM14.152 30a2.153 2.153 0 11-.001 4.306A2.153 2.153 0 0114.152 30zm6 0a2.153 2.153 0 11-.001 4.306A2.153 2.153 0 0120.152 30zm-6 1a1.153 1.153 0 10.001 2.306 1.153 1.153 0 000-2.306zm6 0a1.153 1.153 0 10.001 2.306 1.153 1.153 0 000-2.306zm3.318-14.726a1.153 1.153 0 00-.203 2.286.498.498 0 01.45-.01 1.153 1.153 0 00-.247-2.276zm0-5.144a6.055 6.055 0 015.085 2.755.5.5 0 01-.839.545 5.055 5.055 0 00-4.246-2.3c-1.734 0-3.32.877-4.246 2.3a.5.5 0 01-.838-.545 6.056 6.056 0 015.084-2.755zm0-4.13a9.757 9.757 0 017.345 3.316.5.5 0 01-.75.661A8.757 8.757 0 0023.471 8a8.766 8.766 0 00-6.596 2.984.5.5 0 01-.75-.661A9.765 9.765 0 0123.471 7z","fill":"#979797","fill-rule":"nonzero"}})])
          )
        }
      }
    